import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const daysWithinNextMonth = () => {
  const dates = []
  const today = new Date()

  for (let i = 0; i < 30; i++) {
    const newDate = new Date(today.getTime() + i * 24 * 60 * 60 * 1000)
    const formatDateLabel = dayjs(newDate).format('MMM D, YYYY')
    const label = i === 0 ? `${formatDateLabel} (now)` : formatDateLabel
    const dateISO = dayjs(newDate).utc().set('hour', 0).set('minute', 0).set('second', 0).toISOString()
    dates.push({ value: dateISO, label })
  }

  return dates
}
